export const EXPORT_REPORTS = 'EXPORT_REPORTS';
export const EXPORT_REPORTS_ERROR = 'EXPORT_REPORTS_ERROR';
export const EXPORT_REPORTS_SUCCESS = 'EXPORT_REPORTS_SUCCESS';

export const DOWNLOAD_INCOME_STATEMENT_REPORT = 'DOWNLOAD_INCOME_STATEMENT_REPORT';
export const DOWNLOAD_INCOME_STATEMENT_REPORT_ERROR = 'DOWNLOAD_INCOME_STATEMENT_REPORT_ERROR';
export const DOWNLOAD_INCOME_STATEMENT_REPORT_SUCCESS = 'DOWNLOAD_INCOME_STATEMENT_REPORT_SUCCESS';

export const DOWNLOAD_GL_REPORT = 'DOWNLOAD_GL_REPORT';
export const DOWNLOAD_GL_REPORT_ERROR = 'DOWNLOAD_GL_REPORT_ERROR';
export const DOWNLOAD_GL_REPORT_SUCCESS = 'DOWNLOAD_GL_REPORT_SUCCESS';

export const DOWNLOAD_BALANCE_SHEET_REPORT = 'DOWNLOAD_BALANCE_SHEET_REPORT';
export const DOWNLOAD_BALANCE_SHEET_REPORT_ERROR = 'DOWNLOAD_BALANCE_SHEET_REPORT_ERROR';
export const DOWNLOAD_BALANCE_SHEET_REPORT_SUCCESS = 'DOWNLOAD_BALANCE_SHEET_REPORT_SUCCESS';

export const GET_GL = 'GET_GL';
export const GET_GL_ERROR = 'GET_GL_ERROR';
export const GET_GL_SUCCESS = 'GET_GL_SUCCESS';

export const GET_BALANCE_SHEET = 'GET_BALANCE_SHEET';
export const GET_BALANCE_SHEET_ERROR = 'GET_BALANCE_SHEET_ERROR';
export const GET_BALANCE_SHEET_SUCCESS = 'GET_BALANCE_SHEET_SUCCESS';

export const GET_SOI = 'GET_SOI';
export const GET_SOI_ERROR = 'GET_SOI_ERROR';
export const GET_SOI_SUCCESS = 'GET_SOI_SUCCESS';

export const GET_DRD = 'GET_DRD';
export const GET_DRD_ERROR = 'GET_DRD_ERROR';
export const GET_DRD_SUCCESS = 'GET_DRD_SUCCESS';

export const DRD_DOWNLOAD = 'DRD_DOWNLOAD';
export const DRD_DOWNLOAD_ERROR = 'DRD_DOWNLOAD_ERROR';
export const DRD_DOWNLOAD_SUCCESS = 'DRD_DOWNLOAD_SUCCESS';

export const DRD_DOWNLOAD_PDF = 'DRD_DOWNLOAD_PDF';
export const DRD_DOWNLOAD_PDF_ERROR = 'DRD_DOWNLOAD_PDF_ERROR';
export const DRD_DOWNLOAD_PDF_SUCCESS = 'DRD_DOWNLOAD_PDF_SUCCESS';

export const DRD_EXPORT_PDF = 'DRD_EXPORT_PDF';
export const DRD_EXPORT_PDF_ERROR = 'DRD_EXPORT_PDF_ERROR';
export const DRD_EXPORT_PDF_SUCCESS = 'DRD_EXPORT_PDF_SUCCESS';

export const UPDATE_AMOUNT = 'UPDATE_AMOUNT';
export const UPDATE_SHARE = 'UPDATE_SHARE';
export const UPDATE_DRD = 'UPDATE_DRD';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const UPDATE_INSTITUTE = 'UPDATE_INSTITUTE';

export const EXPORT_COOWNER_SECTION = 'EXPORT_COOWNER_SECTION';
export const EXPORT_COOWNER_SECTION_SUCCESS = 'EXPORT_COOWNER_SECTION_SUCCESS';
export const EXPORT_COOWNER_SECTION_ERROR = 'EXPORT_COOWNER_SECTION_ERROR';

export const UPDATE_COMMON_CHARGE = 'UPDATE_COMMON_CHARGE';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/constants.js